import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importCardDetailsContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "CardDetailsContainer" */
                '@perpay-web/fintech/components/containers/CardDetailsV2Container'
            ),
    );
